import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';

import { Subscription } from 'rxjs';

import { EntitiesComponent } from '../../../entities.component';

import { LoginService } from '../../../../pages/login/login.service';
import { ItemsService as OrganizationService } from '../../../customer/system/organization-info';
import { UserService } from '../../../../shared/service/user.service';
import { AuthService } from '../../../../shared/service/auth.service';
import { AppSubject } from '../../../../shared/app-subject';
import { Severity, ToastService } from '../../../../shared/components/toast/toast.service';
import { Col } from '../../../../shared/model';
import { LazyLoadEvent } from 'primeng-lts/api';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html'
})
export class TopbarComponent implements OnInit, OnDestroy {

  AuthService = AuthService;
  baseWebSocketURL: string = environment.baseWebSocketURL;
  @Input() actionColumnWidth?: number;

  tncnUrl: string = 'https://tncn.t-hoadon.vn';

  @Input() onMessage: () => void = () => {
  };
  @Input() selectionMode: string = 'single';
  selectedItem: any;

  user: any;
  displayName?: string;
  displayQR?: boolean;
  QRdata: any

  decreeAndCircularUsing?: string;

  changingPassword?: boolean;
  productList?: boolean;
  submittedPassword?: boolean;
  changePasswordForm = this.fb.group({
    oldPassword: ['', Validators.required],
    newPassword: ['', Validators.required],
    newPasswordVerify: ['', Validators.required]
  });
  changePasswordError?: string;

  decreeCircularSubscription?: Subscription;
  items: Array<any> = new Array<any>();
  totalRecords: number = 0;
  webSocket?: WebSocket;
  listening?: boolean;
  isSuccess?: boolean;
  title?: string;
  paymentDone?: boolean;


  constructor(
    private fb: FormBuilder,
    private router: Router,
    public entities: EntitiesComponent,
    private loginService: LoginService,
    private organizationService: OrganizationService,
    private toastService: ToastService
  ) {
  }

  cols: Array<Col> = [
    { width: 100, field: 'pseudoId', header: 'Mã gói', type: 'text', matchMode: 'contains', format: 'text', visible: true },
    { width: 100, field: 'productName', header: 'Tên gói', type: 'text', matchMode: 'contains', format: 'text', visible: true },
    { width: 100, field: 'amountValue', header: 'Số lượng', type: 'text', matchMode: 'contains', format: 'text', visible: true },
    { width: 100, field: 'price', header: 'Đơn giá', type: 'text', matchMode: 'contains', format: 'text', visible: true },
  ];

  ngOnInit(): void {
    this.user = UserService.getUser();
    this.decreeCircularSubscription = AppSubject.getDecreeCircular().subscribe((decreeCircular) => {
      this.decreeAndCircularUsing = decreeCircular;
    });
    if (AuthService.hasRoles(['Customer'])) {
      this.loadDecreeCircular();

      this.displayName = this.user.partyTaxId;
    } else {
      this.displayName = this.user.partyName;
    }
    this.tncnUrl =  'https://tncn.t-hoadon.vn';
    this.initWebSocket();
  }

  get tncnTaxDeductionUrl(): string {
    return `${this.tncnUrl}/personal-income-tax/tax-deduction`;
  }

  closeTncnUtilitiesPanel(): void {
    this.entities.activeTopbarAction = '';
  }

  isInvoiceSyncRouteActive(): boolean {
    return this.router.isActive('/customer/invoice-sync', {paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams: 'ignored'});
  }

  initWebSocket(): void {
    const origin = location.origin.replace('http', 'ws').replace('https', 'wws');
    this.webSocket = new WebSocket(`${origin}/${this.baseWebSocketURL}`);
    this.webSocket.addEventListener('open', () => {
      this.webSocket?.send('subscribe:BidvPaymentResult');
    });

    this.webSocket.onclose = (e) => {
      if (e.reason !== 'unmount') {
        this.initWebSocket();
      }
    }
    this.webSocket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.topic === 'BidvPaymentResult') {
        if (this.onMessage) {
          this.onMessage();
        }
        if (this.listening) {
          this.listening = false;
          this.paymentDone = true;
          if (data.showAlert === true) {
            this.isSuccess = true
            this.title = data.title
          } else {
            this.isSuccess = false
            this.title = 'Có lỗi xảy ra!';
          }
        }
      }
    }
  }


  ngOnDestroy(): void {
    if (this.decreeCircularSubscription) {
      this.decreeCircularSubscription.unsubscribe();
    }
    if (this.webSocket) {
      this.webSocket.close(3010, 'unmount');
    }

  }

  loadDecreeCircular(): void {
    this.organizationService.get().subscribe((response) => {
      if (response && response.decreeAndCircularUsing) {
        AppSubject.setDecreeCircular(response.decreeAndCircularUsing);
      }
    });
  }
  setSelectedItem(rowData: any): void {
    this.selectedItem = rowData;
  }
  toggleDecreeCircular(): void {
    this.organizationService.toggleDecreeCircular().subscribe(() => {
      this.loadDecreeCircular();
    });
  }

  changePassword(): void {
    this.changePasswordForm.reset();
    this.changingPassword = true;
  }

  showProductList(): void {
    this.loadLazy({ first: 0, rows: 10, filters: {} })
    this.productList = true;
    this.title = ''
    this.paymentDone = false
  }

  loadLazy(event: LazyLoadEvent): void {
    this.organizationService.getProductList().subscribe((response) => {
      this.totalRecords = response?.totalRecords;
      this.items = response?.listData;
      this.initActions();
    })
  }

  initActions(): void {
    if (this.items && this.items.length) {
      this.items.forEach((item) => {
        item.actions = [
          { icon: 'pi pi-check', styleClass: 'p-button-success', title: 'Thanh toán', command: () => this.doPayment(item) }
        ];
      });
    }
  }

  doPayment(item: any): void {
    this.organizationService.initPayment({ 'productId': item.productId }).subscribe((response) => {
      if (response.vietQRImageBase64) {
        this.displayQR = true
        this.productList = false
        this.QRdata = response.vietQRImageBase64
      }
    })
  }

  onChangePassword(): void {
    if (!this.submittedPassword && this.changePasswordForm.valid) {
      this.submittedPassword = true;
      this.changePasswordError = '';

      this.loginService.changePassword(this.changePasswordForm.value).subscribe(({ isSuccess, messages }) => {
        this.submittedPassword = false;
        if (isSuccess === 'Y') {
          this.toastService.setMessage({ severity: Severity.SUCCESS, detail: messages });
          this.changingPassword = false;
        } else {
          this.changePasswordError = messages;
        }
      }, () => {
        this.submittedPassword = false;
      });
    }
  }
  private buildKeycloakLogoutUrl(): string {
    const keycloakBase = environment.keycloakBase;
    const realm = 'apps_iam';
    const clientId = 'ttc-invoice';
    const appUrl = environment.appUrl;
    const redirectUri = encodeURIComponent(appUrl);

    return `${keycloakBase}/realms/${realm}/protocol/openid-connect/logout`
      + `?client_id=${clientId}`
      + `&post_logout_redirect_uri=${redirectUri}`;
  }


  logout(): void {
    this.loginService.logout().subscribe(() => {
      window.location.href = this.buildKeycloakLogoutUrl();
    });
  }


}
